export class StringFilter {
    public like?: string;
    public equal?: string[];
    public includeBlanks?: boolean;
}
